import React from 'react'

const HeaderText = () => (
  <div className="jumbotron-content">
    <h1 className='black header-text-container'>
      <div className="d-inline d-sm-block">The simple,</div>
      <div className="d-inline d-sm-block">online home loan</div>
    </h1>
    <div className='home-sub-header-container'>
      <div className="d-inline d-sm-block">A faster, smarter journey to financing your dream</div>
      <div className="d-inline d-sm-block"> home and investment property</div>
    </div>
  </div>
);

export default HeaderText
